import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "supplier";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    // //获取供应商列表
    // async getAllProvider({ commit }, payload) {
    //   let result = await api.get(
    //     `/api/WeighingDealer?${queryString.stringify(payload)}`
    //   );
    //   return result.data;
    // },
    //获取客户类别
    async getClientType({ commit }, payload) {
      let result = await api.get(`/api/DataDict?pid=15`);
      return result.data;
    },
    //获取供应商列表
    async getAllProvider({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingDealer?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //获取客户列表
    async getAllClient({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingDealer?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //新增供应商/客户
    async addSupplier({ commit }, payload) {
      let result = await api.post(`/api/WeighingDealer`, payload);
      return result.data;
    },
    //修改供应商/客户
    async editSupplier({ commit }, payload) {
      let result = await api.put(`/api/WeighingDealer`, payload);
      return result.data;
    },
    //获取单个信息供应商/客户
    async getSupplierView({ commit }, payload) {
      let result = await api.get(`/api/WeighingDealer/${payload}`);
      return result.data;
    },
    //删除供应商/客户
    async deleteSupplier({ commit }, payload) {
      let result = await api.delete(`/api/WeighingDealer/${payload}`);
      return result;
    },
    // //获取省份
    // async getProvinces({ commit, state }) {
    //   let result = await api.get(`/api/Area?parentNo=0`);
    //   return result.data;
    // },
    // // 获取地区信息
    // async getArea({ commit }, payload) {
    //   let result = await api.get(`/api/Area?${queryString.stringify(payload)}`);
    //   return result.data;
    // }
  },
  mutations: {},
  getters: {},
});

export default moduleName;
